
export const isNewPaymentPageExperimentEnabled = function() {
  try {
    const pathName = window.location.pathname;
    if (pathName.includes("/v3/")) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};
